import { useTheme } from "@hooks";
import { FutureMoneyDarkLogo } from "./FutureMoneyDarkLogo";
import { FutureMoneyLightLogo } from "./FutureMoneyLightLogo";

export const FutureMoneyLogo = () => {
  const { theme } = useTheme();

  return theme.meta.dark ? <FutureMoneyDarkLogo /> : <FutureMoneyLightLogo />;
};
